export default __webpack_public_path__ + "static/media/Single.203fcf17.png";